export default "__VITE_ASSET__150436b9__"